import React from 'react';
import { Route } from 'react-router-dom';
import Ratelier from './ratelier';
import RoutesEspaceDetenteurs from './routes';
import Arme from './armes/index';
import MesDemarches from './mes-demarches';
import MesTitresDeDetention from './mes-titres-de-detention';
import MonCompte from './mon-compte';
import RechercherNotifications from './notifications';
import MentionsLegales from '../mentions-legales';
import DonneesPersonnelles from '../donnees-personnelles';
import GuideUtilisateurSIA from './aide';
import FeatureFlippingComponent from '../../components/FeatureFlipping/FeatureFlippingComponent';
import { FEATURE_TITRES_DETENTION } from '../../components/FeatureFlipping/featureFlipping.func';
import Accessibilite from './accessibilite';
import { getPath } from '../../utils/router';

const EspaceDetenteurs = () => {
    return (
        <>
            <Route
                path={getPath(RoutesEspaceDetenteurs.subroutes.ratelier)}
                render={(subProps) => <Ratelier {...subProps} />}
            />
            <Route
                path={getPath(RoutesEspaceDetenteurs.subroutes.armes)}
                render={(subProps) => <Arme {...subProps} />}
            />
            <Route
                path={getPath(RoutesEspaceDetenteurs.subroutes.demarches)}
                render={(subProps) => <MesDemarches {...subProps} />}
            />
            <FeatureFlippingComponent featureName={FEATURE_TITRES_DETENTION}>
                <Route
                    path={getPath(RoutesEspaceDetenteurs.subroutes.mesTitresDeDetention)}
                    render={(subProps) => <MesTitresDeDetention {...subProps} />}
                />
            </FeatureFlippingComponent>
            <Route
                path={getPath(RoutesEspaceDetenteurs.subroutes.monCompte)}
                render={(subProps) => <MonCompte {...subProps} />}
            />
            <Route
                path={getPath(RoutesEspaceDetenteurs.subroutes.notification)}
                render={(subProps) => <RechercherNotifications {...subProps} />}
            />
            <Route
                path={getPath(RoutesEspaceDetenteurs.subroutes.mentionsLegales)}
                render={(subProps) => <MentionsLegales {...subProps} />}
            />
            <Route
                path={getPath(RoutesEspaceDetenteurs.subroutes.donneesPersonnelles)}
                render={(subProps) => <DonneesPersonnelles {...subProps} />}
            />
            <Route
                path={getPath(RoutesEspaceDetenteurs.subroutes.guideUtilisateurSIA)}
                render={(subProps) => <GuideUtilisateurSIA {...subProps} />}
            />
            <Route
                path={getPath(RoutesEspaceDetenteurs.subroutes.accessibilite)}
                render={(subProps) => <Accessibilite {...subProps} />}
            />
        </>
    );
};

export default EspaceDetenteurs;
